import { render } from "./OidcCallback.vue?vue&type=template&id=72cdc978"
import script from "./OidcCallback.vue?vue&type=script&lang=js"
export * from "./OidcCallback.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/OidcCallback.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72cdc978"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72cdc978', __exports__)) {
    api.reload('72cdc978', __exports__)
  }
  
  module.hot.accept("./OidcCallback.vue?vue&type=template&id=72cdc978", () => {
    api.rerender('72cdc978', render)
  })

}


export default __exports__